import { useParams } from 'react-router-dom'
import { ConversationsList } from '@/components/ConversationsList'
import { ChatWindow } from '@/components/ChatWindow'

export default function Messages() {
  const { conversationId } = useParams<{ conversationId?: string }>()

  return (
    <div className="container mx-auto px-4 py-8">
      {conversationId ? (
        <ChatWindow conversationId={parseInt(conversationId)} />
      ) : (
        <ConversationsList />
      )}
    </div>
  )
}
